<section class="terms-container">
    <div class="card">
        <div class="card-body">
            <h1 class="card-title h5">TERMS AND CONDITIONS</h1>
            <div>
                <h6 class="font-weight-bold">For conducting the content service “Swipe & Win”</h6>
                <ol class="text-black-50">
                    <li>Available SMS short-codes
                        <ol class="text-black-50">
                            <li>The subscription to the “Swipe & Win” content service is available in Arabic and
                                English
                                languages; it has daily cost XXX with 1 day free of charge trial period.</li>
                            <li>All of the SMS sent to the above short-code are free of charge</li>
                            <li>Operator subscribers may opt in to the subscription service “Swipe & Win” by:</li>
                            <ol class="text-black-50">
                                <li>Sending a valid keyword via SMS to the short-code XXX
                                    (please check section 8.2 for keywords table)</li>
                                <li>Dialing the USSD command XXX</li>
                                <li>By following the “Swipe & Win” link via “XXX” app</li>
                                <li>following the link XXX and get registered online</li>
                            </ol>
                            <li>Upon registration, the users will receive the welcome SMS, 10 points for the upcoming
                                weekly
                                prize and the “Swipe & Win”</li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</section>